import { useState } from "react";
import { cn } from "@/lib/utils";

export interface TouchAccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  icon?: React.ReactNode;
  openRotate?: string;
  hoverRotate?: string;
  className?: string;
}

export function TouchAccordion({
  title,
  children,
  icon = "▼",
  openRotate = "rotate-180",
  hoverRotate = "group-hover:rotate-180",
  className,
}: TouchAccordionProps) {
  const [open, setOpen] = useState(false);

  return (
    <div
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onClick={() => setOpen((v) => !v)}
      className={cn("group cursor-pointer", className)}
    >
      <div className="flex items-center justify-between gap-4">
        {title}
        <span
          className={cn(
            "text-ember text-2xl transition-transform duration-300 shrink-0",
            open && openRotate,
            !open && hoverRotate
          )}
        >
          {icon}
        </span>
      </div>
      <div
        className={cn(
          "grid transition-all duration-500 ease-in-out",
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr] group-hover:grid-rows-[1fr]"
        )}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </div>
  );
}
